module.exports = __webpack_public_path__ + "static/img/solution-5.2a128cc8.png";